import { FunctionComponent, PropsWithChildren } from 'react';
import { useSelector } from '@cbridge-utils/react-redux';

import { userIsManagerSelector } from '../../_selectors/userIsManager.selector';

export const PolicyProtection: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const userIsManager = useSelector(userIsManagerSelector);

  if (!userIsManager) {
    return null;
  }

  return (
    <>
      {children}
    </>
  );
};
